<div class="xilo-input" [ngClass]="showError ? ' form-item error' : 'form-item'">
  <label *ngIf="to.label">
    {{ to.label }}
    <span *ngIf="to?.required" class="required-indicator">*</span>
  </label>
  <div class="radio-wrapper" [ngStyle]="styleRadios(to?.options)">
    <div *ngFor="let option of to.options; let i = index" class="radio" [ngStyle]="styleRadio(to?.options)" [ngClass]="checked(option.value) ? 'checked' : ''">
      <label class="radio-rounded">
        {{ option.label }}
        <input
          #radioInput
          type="radio"
          [name]="radioKey()"
          [id]="option.label"
          [value]="option.value"
          [checked]="checked(option.value)"
          (keydown)="onArrowKeydown($event, i)"
          (change)="onRadioChange(option.value)"
          [formlyAttributes]="field"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
</div>
